import type { HTMLAttributes } from "react";
import MinusIcon from "@/assets/icons/minus.svg";
import PlusIcon from "@/assets/icons/plus.svg";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";
import { FilterCounter } from "./filter-counter";

type FilterBlockProps = HTMLAttributes<HTMLDivElement> & {
  label?: string | React.ReactNode;
  name: string;
  children: React.ReactNode;
  filterCounter?: "mobile" | true | false;
};

export const FilterBlock = ({
  label,
  children,
  name,
  filterCounter,
  ...props
}: FilterBlockProps) => {
  return (
    <AccordionItem
      value={name}
      className={cn("rounded-2xl bg-brand-grey1", props.className)}
    >
      {label && (
        <AccordionTrigger
          className="px-4 [&[data-state=closed]_.minus]:hidden [&[data-state=open]>svg]:rotate-0 [&[data-state=open]_.plus]:hidden [&_.lucide-chevron-down]:hidden"
          showArrow={false}
        >
          {label}{" "}
          {filterCounter && (
            <FilterCounter
              className={cn(
                "ml-2",
                filterCounter === "mobile" ? "lg:hidden" : "",
              )}
              param={name}
            />
          )}
          <MinusIcon className="minus ml-auto" />
          <PlusIcon className="plus ml-auto" />
        </AccordionTrigger>
      )}
      <AccordionContent className="p-4 pt-0">
        <div className={cn("border-brand-green1-300/15 pt-4", label && "border-t")}>
          {children}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
